export const REGEX = {
  ONLY_NUMBER: /^\d+$/,
  NON_ZERO_NUMBER: /^(?!0)\d+$/,
  NO_ZERO_LEADING_NUMBER: /^(0|[1-9]\d*)$/,
  NO_FRONT_SPACE: /^[^\s].*$/,
  NO_END_SPACE: /^.*[^\s]$/,
  HTML_TO_TEXT: /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g,
  ASCII: /^[\u0020-\u007E]*$/,

  DIGITS_ONLY: /^[1-9]\d*$/,
  NUMBERS_WITH_DECIMAL: /^\d*\.?\d*$/,
  ALPHABET_ONLY: /^[A-Za-z\s]*$/,
};
